import React, { Component, PropTypes } from 'react';
import { Map } from 'immutable';
import Dropdown from 'shared/components/menus/dropDown';

class ColumnMenu extends Component {
  render() {
    return (
      <div className="column-selector-dropdown">
        <Dropdown config={this._getConfig()} />
      </div>
    );
  }

  _getConfig() {
    let { activeId, columns } = this.props;

    let activeColumn = columns
      ? columns.find((column) => column.get('_id') === activeId)
      : null;
    let content =
      activeId && columns && activeColumn
        ? this._getContent(activeColumn)
        : 'Select Column';

    return Map({
      noCaret: false,
      icon: null,
      content,
      items: this._getItems(),
    });
  }

  _getItems() {
    let { columns } = this.props;

    if (!columns || columns.size < 1) return [];

    return columns.map((column, columnId) => {
      return Map({
        type: 'link',
        content: this._getContent(column),
        onClick: () => this._handleSelection(columnId),
      });
    });
  }

  _getContent(column) {
    return column.get('title');
  }

  _handleSelection(columnId) {
    this.props.onChange(columnId);
  }
}

ColumnMenu.propTypes = {
  activeId: PropTypes.string.isRequired,
  columns: PropTypes.object.isRequired, //OrderedMap<Column>
  onChange: PropTypes.func.isRequired,
};

export default ColumnMenu;
